// src/models/pedidos/PedidoItem.js
// models/pedidos/PedidoItem.js
import { Produto } from '../produtos/Produto'; // Supondo que Produto.js exista em models/produtos

export class PedidoItem {
    constructor(
        id = 0,
        pedidoId = 0,
        produtoId = 0,
        qtde = 0,
        valor = 0,
        observacao = null,
        variacao = null,
        produto = new Produto()
        // pedidoItemSabores = null // Comentado como no C#
    ) {
        this.id = id;                  // int
        this.pedidoId = pedidoId;      // int
        this.produtoId = produtoId;    // int
        this.qtde = qtde;              // decimal
        this.valor = valor;            // decimal
        this.observacao = observacao;  // string? (nullable)
        this.pedidoItemVariacoes = [];
        this.variacao = variacao;// string? (nullable)
        this.produto = produto;        // Produto? (nullable)
        // this.pedidoItemSabores = pedidoItemSabores; // List<PedidoItemSabor>? (nullable) - Comentado
    }
}